<template>
  <el-dialog
    :title="model.id > 0 ? '编辑设备' : '添加设备'"
    :visible.sync="visible"
    label-width="100px"
    width="40%"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
    >
      <el-form-item label="名称">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
      <!-- <el-form-item label="分类" prop="category">
        <el-select v-model="model.category" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in categories.filter(item => item.father_id == 0)"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="分类">
        <el-select
          v-model="model.item_category_id"
          filterable
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.whole_name.replace(/,/g, '-')"
            :value="item.id"
          ></el-option>
          <!-- <el-option-group v-for="group in options" :key="group.label" :label="group.label">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="parseInt(item.value)"
            ></el-option>
          </el-option-group>-->

          <!-- <el-option
            v-for="item in categories"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>-->
        </el-select>
      </el-form-item>

      <el-form-item label="机型">
        <el-input v-model="model.machine_type" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="件号" prop="part_number">
        <el-input v-model="model.part_number" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="供应商" v-if="showSupplier">
        <el-select
          v-model="model.supplier_id"
          filterable
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in suppliers"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="参数">
        <el-input
          v-model="model.params"
          type="textarea"
          placeholder="如功率，流量等"
          autocomplete="off"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="描述">
        <el-input
          v-model="model.description"
          type="textarea"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="成本价" prop="price">
        <el-input-number
          v-model="model.cost_price.price"
          :precision="2"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="定价" prop="price">
        <el-input-number
          v-model="model.price"
          :precision="2"
          :min="0"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  createItem,
  updateItem,
  itemCategoryList,
  supplierList,
} from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    showSupplier: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    // 'model.category': function() {
    //   this.model.item_category_id = ''
    // }
  },
  created() {
    this.requestItemCategories()
    if (this.showSupplier) {
      this.requestSuppliers()
    }
  },
  data() {
    return {
      categories: [],
      options: [],
      suppliers: [],
      visible: this.show,
      rules: {
        name: [{ required: true, message: '请填写设备名称', trigger: 'blur' }],
        // category: [
        //   { required: true, message: '请选择设别种类', trigger: 'blur' }
        // ]
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.model.item_category_id =
            parseInt(this.model.item_category_id) || 0
          this.model.supplier_id = parseInt(this.model.supplier_id) || 0
          if (this.model.id > 0) {
            let res = await updateItem(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createItem(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async requestItemCategories() {
      let res = await itemCategoryList({ page: 0, size: 1000, category: 2 })
      if (res.code == 0) {
        this.options = res.data.list
        // let fathers = res.data.list.filter(item => item.father_id == 0)
        // fathers.map(item => {
        //   let option = { label: item.name, options: [] }
        //   res.data.list
        //     .filter(it => it.father_id == item.id)
        //     .map(i => {
        //       option.options.push({ label: i.name, value: i.id })
        //     })
        //   this.options.push(option)
        // })
      }
    },
    async requestSuppliers() {
      let res = await supplierList({ page: 0, size: 1000 })
      if (res.code == 0) {
        this.suppliers = res.data.list
      }
    },
  },
}
</script>